import React from "react";
import AccountManagement from "./Portfolio/AccountManagement";

export default function AccountsPage() {
    return (
        <div className="max-w-4xl mx-auto space-y-6">
            <div>
                <h1 className="text-2xl font-semibold text-gray-900 tracking-tight">Accounts</h1>
                <p className="text-gray-500 mt-1">Manage your linked financial accounts</p>
            </div>

            <AccountManagement />
        </div>
    );
}
